export default __webpack_public_path__ + "static/media/scatterPlot.37728a80.png";